import React, {useEffect, useState} from "react";
import axios from "axios";
import Chart from "../Data/Chart";
import StateBar from "../Data/StateBar";
import DateSelector from "../Components/DateSelector";
import {MapContainer, Marker, TileLayer, useMap} from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import L from "leaflet";
import {useParams} from "react-router-dom";
import {Slider} from "@mui/material";
import DateSelectorNew from "../Components/DateSelector";

const CenterMapOnUpdate = ({ position, shouldCenter }) => {
    const map = useMap();

    useEffect(() => {
        if (shouldCenter && position) {
            map.setView(position, 13);
            map.invalidateSize();
        }
    }, [map, position, shouldCenter]);

    return null;
};

const svgIcon = `
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="40" fill="orange" stroke="white" stroke-width="10" />
        </svg>
    `;

const customIcon = L.divIcon({
    className: '',
    html: svgIcon,
    iconSize: [30, 30],
    iconAnchor: [15, 15], // Center the icon
});

const LMBLoggingDashboard = () => {
    const [Data, setData] = useState({
        spoor: [],
        spoorstand: [],
        legendas: {},
        speed: [],
        location: null
    })
    const [Machine, setMachine] = useState({
        alias: null,
        organization: null,
        loggerid: null
    });
    const [slider, setSlider] = useState(0)

    const alias = useParams()

    const [dateRange, setDateRange] = useState([new Date("2025-04-12T08:00:00").toISOString(), new Date("2025-04-12T20:00:00").toISOString()]);

    const getData = async () => {
        try {
            console.log(Machine.loggerid)
            const response = await axios.get("/api/berend/get/data", {
                params: {start: dateRange[0], end: dateRange[1], loggerid: Machine.loggerid},
            });
            setData(response.data);
        } catch (error) {
            console.error("Error fetching machine data:", error);
        }
    }

    const getMachine = async () => {
        try {
            const response = await axios.get("/api/berend/get/one", {
                params: alias,
            });
            setMachine(response.data);
        } catch (error) {
            console.error("Error fetching machine data:", error);
        }
    }

    useEffect(() => {
        getData()
    }, [Machine])

    useEffect(() => {
        getMachine()
    }, []);

    const renderMap = () => (
        <div className="w-full h-full min-h-96 relative">
            <MapContainer
                center={Data ? Data.position : [0,0]}
                zoom={13}
                style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "6px",
                    zIndex: 0,
                }}
                whenReady={(mapInstance) => {
                    setTimeout(() => {
                        mapInstance.target.invalidateSize();
                    }, 100);
                }}
            >
                <Marker icon={customIcon} position={Data ? Data.postition ? Data.position : [0,0] : [0,0]}></Marker>
                <CenterMapOnUpdate position={Data ? Data.position : [0,0]} shouldCenter={true} />
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
            </MapContainer>
        </div>
    );

    return (
        <div className="w-full h-full px-10 gap-4 py-4 grid 2xl:grid-cols-5 grid-cols-3 grid-rows-3">
            <div className="flex flex-col relative row-span-3 bg-white shadow rounded">
                <div className="flex flex-col w-full gap-4 items-center p-4">
                    <div className={"rounded-full font-bold w-40 h-40 flex bg-gradient-to-br from-yellow-400 to-orange-600 items-center justify-center text-4xl text-white shadow-xl shadow-gray-400"}>
                        {Machine.alias ? Machine.alias.substring(0, 1) : ""}
                    </div>
                    <h1 className={"text-4xl font-semibold border-b-2 pb-6 w-full text-center border-gray-400"}>{Machine.alias}</h1>
                    <div>
                        <h1 className={"font-bold text-3xl text-center"}>LoggerID:</h1>
                        <h1 className={"text-2xl text-center"}>{Machine.loggerid}</h1>
                    </div>
                    <div>
                        <h1 className={"font-bold text-3xl text-center"}>Organisatie:</h1>
                        <h1 className={"text-2xl text-center"}>{Machine.cleanorg}</h1>
                    </div>
                </div>
                <div className="flex flex-col absolute bottom-3 w-full items-center p-4">
                    <DateSelectorNew dateRange={dateRange} setDateRange={setDateRange}/>
                    <button className={"bg-orange-500 text-white text-xl font-bold px-6 py-2 rounded"} onClick={getData}>Update Data</button>
                </div>
            </div>
            <div className="flex flex-col col-start-2 col-span-2 row-span-3 gap-4">
                {renderMap()}
                <div className={"flex flex-col px-4 bg-white shadow rounded"}>
                    <Slider value={slider} onChange={(_, value) => setSlider(value)} max={1000}></Slider>
                </div>
                <Chart width={1250} name={"Snelheid"} data={Data.speed}></Chart>
            </div>
            <div className="justify-between gap-4 flex 2xl:flex-col 2xl:col-start-4 2xl:col-span-2 col-span-3 2xl:row-start-1 row-start-4 row-span-3">
                <StateBar width={1250} xpadding={210} name={"Machinestatus"} data={Data.machinestatus} legendaitems={Data.legendas.machinestatus} slider={slider}></StateBar>
                <StateBar width={1250} xpadding={210} name={"Spoordata"} data={Data.spoordata} legendaitems={Data.legendas.spoordata} slider={slider}></StateBar>
            </div>
        </div>
    )
}

export default LMBLoggingDashboard;